import './FeedEventTag.scss';

interface TagConfig {
  color: string;
  label: string;
}

// Map event types to display config
const EVENT_TYPE_CONFIG: Record<string, TagConfig> = {
  // New feed event types
  CONTACT_OBSERVED: { color: 'blue', label: 'Contact Observed' },
  EMAIL_VERIFIED: { color: 'green', label: 'Email Verified' },
  CONTACT_FIELD_CHANGED: { color: 'teal', label: 'Contact Field Changed' },
  // Legacy event types (if any remain)
  CONTACT_CREATED: { color: 'green', label: 'Contact Created' },
  CONTACT_RECORD_CREATED: { color: 'teal', label: 'Contact Record Created' },
  INSTITUTION_CREATED: { color: 'blue', label: 'Institution Created' },
  INSTITUTION_UPDATED: { color: 'cyan', label: 'Institution Updated' },
  NC_CC_LINKED: { color: 'indigo', label: 'Contact Linked' },
  CC_UPDATED: { color: 'magenta', label: 'Contact Updated' },
  FIELD_CHANGED: { color: 'lime', label: 'Field Changed' },
};

function getDefaultConfig(eventType: string): TagConfig {
  const label = eventType
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
  return { color: 'gray', label };
}

interface FeedEventTagProps {
  eventType: string;

  /**
   * Drop the leading "Contact" from the label - "Contact Observed" becomes "Observed".
   *
   * On a single contact's page every row is about that contact, so the word carries no
   * information and costs the column width that makes a dense table readable. Done as a
   * rule rather than a second label table so the two cannot fall out of step: it also
   * shortens Contact Created, Contact Updated and Contact Linked, while leaving
   * Institution and Email labels alone, where the noun is doing real work.
   */
  short?: boolean;
}

export function FeedEventTag({ eventType, short }: FeedEventTagProps) {
  // Default: single tag for all event types
  const config = EVENT_TYPE_CONFIG[eventType] || getDefaultConfig(eventType);
  const label = short ? config.label.replace(/^Contact /, '') : config.label;

  return (
    <span className={`feed-event-tag feed-event-tag--${config.color}`}>
      {label}
    </span>
  );
}
